import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/styles'
import {
  Divider,
  SwipeableDrawer,
  colors,
  Button,
  Hidden
} from '@material-ui/core'

import {
  OutlinedFlag as OutlinedFlagIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Settings as SettingsIcon,
  Timeline as TimelineIcon,
  Assessment as AssessmentIcon,
  Input as InputIcon,
  Help as HelpIcon,
  ShoppingCart as ShoppingCartIcon
} from '@mui/icons-material'

import { Profile, SidebarNav } from './components'

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2),
    height: '100%',
    flexGrow: 1
  },
  button: {
    color: colors.blueGrey[800],
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  }
}))

const Sidebar = props => {
  const {
    open,
    variant,
    onClose,
    onOpen,
    className,
    user,
    storeId,
    storeProfileImage,
    storeLocation,
    onLogoff,
    ...rest
  } = props

  const classes = useStyles()
  const pages = [
    {
      title: 'Início',
      href: `/${storeId}/dashboard`,
      icon: <DashboardIcon />
    },
    {
      title: 'Lançamentos',
      href: `/${storeId}/inputs`,
      icon: <InputIcon />
    },
    {
      title: 'Atendimentos',
      href: `/${storeId}/events`,
      icon: <ShoppingCartIcon />
    },
    {
      title: 'Relatórios',
      href: `/${storeId}/report`,
      icon: <AssessmentIcon />
    },
    {
      title: 'Usuários',
      href: `/${storeId}/users`,
      icon: <PeopleIcon />
    },
    {
      title: 'Metas',
      href: `/${storeId}/goals`,
      icon: <TimelineIcon />
    },
    {
      title: 'Corridinhas',
      href: `/${storeId}/sprints`,
      icon: <OutlinedFlagIcon />
    },
    {
      title: 'Configurações',
      href: `/${storeId}/settings`,
      icon: <SettingsIcon />
    }
  ]

  return (
    <SwipeableDrawer
      anchor='left'
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      onOpen={onOpen}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <Profile
          storeProfileImage={storeProfileImage}
          user={user}
          storeLocation={storeLocation}
          storeId={storeId}
        />
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
        <Divider className={classes.divider} />
        <Button
          className={classes.button}
          target='_blank'
          href='https://wa.me/5544991546704'
        >
          <div className={classes.icon}>
            <HelpIcon />
          </div>
          Suporte
        </Button>
        <Hidden lgUp>
          <Button className={classes.button} onClick={onLogoff}>
            <div className={classes.icon}>
              <InputIcon />
            </div>
            Sair
          </Button>
        </Hidden>
      </div>
    </SwipeableDrawer>
  )
}

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
  storeProfileImage: PropTypes.string,
  storeLocation: PropTypes.string
}

export default Sidebar
